import React, { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import {
    acceptInvitation,
    getUserExistsValue
} from "../../../../../../Actions/API/Collaborator/CollaboratorActions"
import { useAppState } from "../../../../../../Hooks/useReduxState"
import { Invitation } from "../../../../../../Models/Client/Invitation"
import { routePaths } from "../../../../../../Routes"
import { InvitationAccept } from "../../../Common/InvitationAccept"

interface AppCollaboratorsSignUpProps {
    orgUsername: string
    appId: string
    collaborationId: number
    code: string
}

export function AppCollaboratorsSignUp({
    orgUsername,
    appId,
    collaborationId,
    code
}: AppCollaboratorsSignUpProps) {
    const dispatch = useDispatch()
    const email = useAppState(
        state => state.api.authentication.ownerExists[collaborationId]?.email
    )
    const invitation = useMemo<Invitation>(
        () => ({
            type: "collaborator" as const,
            collaborationId,
            code
        }),
        [code, collaborationId]
    )

    useEffect(() => {
        if (email === undefined) {
            dispatch(getUserExistsValue(collaborationId, code))
        }
    }, [code, dispatch, email, collaborationId, orgUsername, invitation])

    return (
        <InvitationAccept
            invitation={invitation}
            email={email}
            acceptAction={acceptInvitation(collaborationId, code)}
            redirectRouteOnComplete={routePaths.appDetail(orgUsername, appId)}
        />
    )
}
